module.exports = __webpack_public_path__ + "img/overdue-filter_fetch.1c3b573f.svg";